module.exports = __webpack_public_path__ + "img/en_trainBackImg.dfbf4b92.jpg";